/* eslint-disable jsx-a11y/anchor-is-valid */
import React ,{useEffect,useState} from "react";
import { Tab , Nav } from "react-bootstrap";
import {Security} from "./Security"
import { TimeZone } from "./TimeZone";
export const Settings = (props) => {
    const [key, setKey] = useState('security');

    return (
        <div className="container-fluid">
            <Tab.Container id="settingTab" activeKey={key} onSelect={(k) => setKey(k)}>
            <div className="row">
                    <div className="col-md-3">
                        <div className="card custom-card gutter-b border-0 rounded-0">
                            <div className="card-body p-3">
                                <Nav
                                    variant="pills"
                                    className="flex-column custom_nav"
                                >
                                    <Nav.Item className="border-bottom">
                                        <Nav.Link className="flex-wrap" eventKey="security">
                                           <span className="font-size-h5 px-0 col-12">{props.language.SETTING_SECURITYANDLOGIN}</span >
                                           <span className="text-muted small px-0 col-12">{props.language.SETTING_UPDATE_YOUR_PASSWORD}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                     <Nav.Item >
                                        <Nav.Link className="flex-wrap" eventKey="timezonesetting">
                                            <span className="font-size-h5 px-0 col-12">Timezone</span >
                                            <span className="text-muted small px-0 col-12">Change your Timezone</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 bg-white rounded p-8"style={{boxShadow:"rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px"}}>
                        <div className="card custom-card rounded-0">
                            <div className="card-body">
                                <Tab.Content>
                                    <Tab.Pane eventKey="security">
                                        <Security language={props.language}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="timezonesetting">
                                        <TimeZone userinfo={props.userinfo} language={props.language}/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div>
            </Tab.Container>
        </div>
    );
};
